import React from 'react';

import svg from './assets/icons-32-menu.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconMenu = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-menu" />;
